"use client"

import type React from "react"

import { useState } from "react"
import { usePathname } from "next/navigation"
import CustomerSidebar from "./customer-sidebar"
import { SidebarProvider } from "@/components/ui/sidebar"

export default function CustomerLayout({ children }: { children: React.ReactNode }) {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false)
  const pathname = usePathname()

  const getPageTitle = () => {
    switch (pathname) {
      case "/customer/profile":
        return "Начало"
      case "/customer/orders":
        return "Поръчки"
      case "/customer/pet":
        return "Моите любимци"
      case "/customer/autoship":
        return "Регулярна доставка"
      case "/customer/bank-card":
        return "Банкова карта"
      default:
        return "Начало"
    }
  }

  return (
    <SidebarProvider>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-6 lg:hidden">{getPageTitle()}</h1>

        <div className="flex flex-col lg:flex-row gap-6">
          {/* Mobile sidebar toggle */}
          <button
            className="lg:hidden flex items-center gap-2 mb-4 text-sm font-medium"
            onClick={() => setIsMobileSidebarOpen(true)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-5 h-5"
            >
              <line x1="4" x2="20" y1="12" y2="12"></line>
              <line x1="4" x2="20" y1="6" y2="6"></line>
              <line x1="4" x2="20" y1="18" y2="18"></line>
            </svg>
            Menu
          </button>

          {/* Sidebar for desktop */}
          <div className="hidden lg:block w-64 flex-shrink-0">
            <CustomerSidebar
              isMobileSidebarOpen={isMobileSidebarOpen}
              setIsMobileSidebarOpen={setIsMobileSidebarOpen}
            />
          </div>

          {/* Mobile sidebar */}
          {isMobileSidebarOpen && (
            <>
              <div
                className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
                onClick={() => setIsMobileSidebarOpen(false)}
              />
              <div className="fixed inset-y-0 left-0 z-50 w-64 bg-white p-4 lg:hidden">
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-xl font-bold">My Account</h2>
                  <button onClick={() => setIsMobileSidebarOpen(false)}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="w-5 h-5"
                    >
                      <path d="M18 6 6 18"></path>
                      <path d="m6 6 12 12"></path>
                    </svg>
                  </button>
                </div>
                <CustomerSidebar
                  isMobileSidebarOpen={isMobileSidebarOpen}
                  setIsMobileSidebarOpen={setIsMobileSidebarOpen}
                />
              </div>
            </>
          )}

          {/* Main content */}
          <div className="flex-1">{children}</div>
        </div>
      </div>
    </SidebarProvider>
  )
}
